import React from "react";

const PaymentMethodRadio = (props) => {
  return (
    <>
      <div
        className={`d-flex align-items-center overflow-hidden ${
          props.name === "paymentMethod" && props.label !== "Transfer Bank BCA" && props.label !== "Maybank" ? "mb-4" : "mb-0"
        }`}
      >
        <input
          type="radio"
          className="form-check-input flex-shrink-0"
          name={props.name}
          id={props.value}
          value={props.value}
          title={props.label}
          onChange={(e) => props.handler(e)}
          checked={props.data?.label === props.label}
          fee={props.fee ? props.fee : 0}
          add={props.add ? props.add : 0}
          feetype={props.feetype ? props.feetype : ""}
          payment={props.typePayment ? props.typePayment : ""}
        />
        <label
          htmlFor={props.value}
          className="d-flex flex-column text-truncate"
          title={props.label}
        >
          <div className="d-flex align-items-center w-100">
            <div
              className="brand-wrapper"
              style={{ marginRight: "8px" }}
            >
              <img src={props.icon} alt={props.value + ".png"} />
            </div>
            <span className="label-title text-truncate">{props.label}</span>
          </div>
        </label>
      </div>
      {props.label === "Transfer Bank BCA" && (
        <div className="d-flex align-items-center w-100 mb-3" style={{ marginLeft: "18px" }}>
          <div className="brand-wrapper" style={{ marginRight: "8px", visibility: "hidden" }}>
            <img src={props.icon} alt={props.value + ".png"} />
          </div>
          <span
            className="p-1 text-muted small fw-light text-wrap"
            style={{ maxWidth: "100%" }}
          >
            Dengan kode unik otomatis, Kode unik akan dikembalikan ke deposit
          </span>
        </div>
      )}
      {props.label === "Maybank" && (
        <div className="d-flex align-items-center w-100 mb-3" style={{ marginLeft: "18px" }}>
          <div className="brand-wrapper" style={{ marginRight: "8px", visibility: "hidden" }}>
            <img src={props.icon} alt={props.value + ".png"} />
          </div>
          <span
            className="p-1 text-muted small fw-light text-wrap"
            style={{ maxWidth: "100%" }}
          >
            Pengecekan Hanya di Sen-Jum 08.00-17.00 WIB
          </span>
        </div>
      )}
    </>
  );
};

export default PaymentMethodRadio;
